var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Alert",class:{
    'Alert--success': _vm.type === 'success',
    'Alert--danger': _vm.type === 'danger',
    'Alert--info': _vm.type === 'info',
    'Alert--warning': _vm.type === 'warning',
  }},[_c('div',{staticClass:"ml-4 Alert__Body"},[_c('p',{staticClass:"text-primary-700 font-bold",attrs:{"role":"alert","aria-live":_vm.type === 'danger' ? 'assertive' : 'polite'}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"text-sm text-primary-500",attrs:{"role":"alert","aria-live":_vm.type === 'danger' ? 'assertive' : 'polite'}},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }